// T-371d — quelle demande de paiement est utile pour ce dossier (une seule à la fois). La règle est CALCULÉE PAR LE SERVEUR (étape du dossier, instantané ANAH) :
// l'écran ne devine plus à partir de champs que les dossiers ne portent pas. Fonctions pures, sans dépendance : testables seules.
export const PHASES_UTILES = ["avance", "solde"];

/** Lit la réponse de `GET /api/metier/agents/depot/paquet/phase-utile` : « avance », « solde » ou null (toute autre valeur = rien). */
export function phaseUtile(reponse) {
  const phase = reponse && reponse.phase;
  return PHASES_UTILES.includes(phase) ? phase : null;
}

export function urlPhaseUtile(api, reference) {
  return `${api}/api/metier/agents/depot/paquet/phase-utile?reference=${encodeURIComponent(reference)}`;
}

/** T-372f : « Annuler la demande » n'est proposé que si le serveur dit que OmniHub a posé la date (jamais une date importée). */
export function demandeAnnulable(reponse) {
  return Boolean(reponse && reponse.annulable === true);
}
